import * as preact from 'preact'

const { h, Component } = preact

type Props = {
  tag?: string,
  children?: any,
  class?: string
}

export class HTML extends Component<Props, {}> {
  static defaultProps = {
    tag: 'div',
    children: []
  }
  shouldComponentUpdate() {
    return false
  }
  render() {
    const { tag, children, ...rest } = this.props
    return h(tag, Object.assign({}, { dangerouslySetInnerHTML: { __html: children } }, rest))
  }
}



// WEBPACK FOOTER //
// ./src/v1/components/lib/HTML.tsx